// downloader -> player
export const kVideoPacket = 0;
export const kWsEvent = 1;

// decoder -> player
export const kVideoFrame = 0;

// player -> downloader
export const kStartDownloader = 0;
export const kStopDownloader = 1;
export const kAcquireMore = 2;

// player -> decoder
export const kStartDecoder = 0;
export const kStopDecoder = 1;
export const kPushDecoder = 2;

// 生产环境减少log
export const isProd = true;
// console.log(isProd);

export function Logger(module) {
  this.module = module;
}

Logger.prototype.log = function (line) {
  if (isProd) return;
  console.log(`[${this.currentTimeStr()}][${this.module}]${line}`);
};

Logger.prototype.logError = function (line) {
  if (isProd) return;
  console.log(`[${this.currentTimeStr()}][${this.module}][ER] ${line}`);
};

Logger.prototype.logInfo = function (line) {
  if (isProd) return;
  console.log(`[${this.currentTimeStr()}][${this.module}][IF] ${line}`);
};

Logger.prototype.logDebug = function (line) {
  if (isProd) return;
  console.log(`[${this.currentTimeStr()}][${this.module}][DT] ${line}`);
};

Logger.prototype.currentTimeStr = function () {
  const now = new Date(Date.now());
  const year = now.getFullYear();
  const month = now.getMonth() + 1;
  const day = now.getDate();
  const hour = now.getHours();
  const min = now.getMinutes();
  const sec = now.getSeconds();
  const ms = now.getMilliseconds();
  return `${year}-${month}-${day} ${hour}:${min}:${sec}:${ms}`;
};